import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getRequestDateFoodMeal, emptyRequestDateFoodMeal} from './Module';
import {Form, Select as SelectInput} from 'antd';
import jMoment from 'components/classes/Jmomen';
import uuidv1 from 'uuid/v1';
import MaterialIcon from 'components/common/MaterialIcon';
import SelectDateFoodMeal from './Module'

@connect((state) => ({
  dateFoodMeal: state.FormBuilder.Common.SelectDateFoodMeal.dateFoodMeal,
}), {
  getRequestDateFoodMeal,
  emptyRequestDateFoodMeal,
})
@autobind
/**
 *
 */
export default class SelectDateFoodMealInfo extends React.PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string,
    dateFoodMealId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    dateFoodMeal: PropTypes.object,
    getRequestDateFoodMeal: PropTypes.func,
    emptyRequestDateFoodMeal: PropTypes.func,
  };

  static defaultProps = {
    inline: true,
    label: undefined,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      dateFoodMeal: {},
      render: true,
    };
  }


  /**
   *
   */
  componentDidMount() {
    const {getRequestDateFoodMeal} = this.props;
    getRequestDateFoodMeal(this.props.dateFoodMealId, {
      includes: ['food:id,title', 'meal:id,title,color', 'self:id,title'],
    }, (r) => {
      this.setState({dateFoodMeal: r});
    });
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(np.dateFoodMealId, this.props.dateFoodMealId)) {
      np.getRequestDateFoodMeal(np.dateFoodMealId, {
        includes: ['food:id,title', 'meal:id,title,color', 'self:id,title'],
      }, (r) => {
        this.setState({dateFoodMeal: r});
      });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();
    this.props.emptyRequestDateFoodMeal();
  }


  /**
   *
   * @return {Object}
   * @private
   */
  _inline() {
    const {inline} = this.props;

    if (inline) {
      return {
        labelCol: {span: 6},
        wrapperCol: {span: 18},
      };
    }

    return {};
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {dateFoodMeal, label} = this.props;
  console.log("dateFoodMeal",dateFoodMeal);
  
    return (
      <span>
        {dateFoodMeal  && <span>{`${dateFoodMeal}`}</span>}

        </span>
    );
  }
}
